//#region DevExtreme Imports

import 'devextreme/ui/button'
import 'devextreme/ui/check_box'
import 'devextreme/ui/date_box'
import 'devextreme/ui/radio_group'
import 'devextreme/ui/text_area'

//#endregion

import { USER_SESSION_SERVICE_NAME } from '../../../../../services/user-session'
import { REFERENCE_TYPE_SERVICE_NAME } from '../../../../../services/reference-type'
import { IMRBaseComponent } from '../../../base'
import { AstGsmActionController } from './action-run.dedicated.ast-gsm.controller'

export const COMPONENT_NAME: string = 'astGsmAction'

//#region Asset Imports

import './action-run.dedicated.ast-gsm.scss'
import * as TEMPLATE from './action-run.dedicated.ast-gsm.tpl.html'

//#endregion

export class AstGsmActionComponent extends IMRBaseComponent {
	constructor() {
		super({
			controller: AstGsmActionController,
			template: TEMPLATE,
			services: [USER_SESSION_SERVICE_NAME, REFERENCE_TYPE_SERVICE_NAME],
		})
	}
}
